import { retrieveRecentMatters } from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveRecentMattersQueryOptions = () => ({
  queryKey: [queryKeys.recentMatters],
  queryFn: retrieveRecentMatters,
});
